/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAllConversationSearchDto } from '../../models/api-response-paged-result-all-conversation-search-dto';
import { PagedRequestAllConversationSearchDto } from '../../models/paged-request-all-conversation-search-dto';

export interface ListOfAllConversations$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAllConversationSearchDto
}

export function listOfAllConversations(http: HttpClient, rootUrl: string, params: ListOfAllConversations$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAllConversationSearchDto>> {
  const rb = new RequestBuilder(rootUrl, listOfAllConversations.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAllConversationSearchDto>;
    })
  );
}

listOfAllConversations.PATH = '/v1/api/admin-ui/conversation/list';
